import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { Component } from 'vue-property-decorator';
import VueCurrencyInput from 'vue-currency-input';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import { configAxios } from '@/plugins/axios';
import { configI18n } from '@/plugins/i18n';
import { configSentry } from '@/plugins/sentry';

// configure pluggins
configI18n();
configAxios();
configSentry();

// config vuelidate
Vue.use(Vuelidate);
Component.registerHooks(['validations']);
Vue.use(VueCurrencyInput, { globalOptions: { currency: null }});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
